import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from './../shared/shared.module';
import { PopoverModule } from 'ngx-bootstrap/popover';

import { AccordionModule } from 'ngx-bootstrap/accordion';
import { ModalModule } from 'ngx-bootstrap/modal';
import { AlertModule } from 'ngx-bootstrap/alert';
import { CaseViewComponent } from './case-view.component';
import { CivilCaseViewComponent } from './civil/civil-case-view.component';
import { JudgmentsComponent } from './civil/judgments/judgments.component';
import { PleadingsComponent } from './civil/pleadings/pleadings.component';
import { PartiesComponent } from './civil/parties/parties.component';
import { AttorneysComponent } from './civil/attorneys/attorneys.component';
import { TransferAppealsComponent } from './civil/transfer-appeals/transfer-appeals.component';
import { ServiceDocumentsComponent } from './civil/service-documents/service-documents.component';
import { CaseEventHistoryComponent } from './civil/case-event-history/case-event-history.component';
import { CivilCaseInformationComponent } from './civil/civil-case-information/civil-case-information.component';
import { TranscriptComponent } from './civil/transcript/transcript.component';
import { CreditorSectionComponent } from './civil/judgments/creditor-section.component';
import { DocumentsComponent } from './civil/documents/documents.component';
import { DocumentViewerComponent } from './civil/documents/document-viewer.component';
import { DocumentsService } from './civil/documents/documents.service';

import { JuvenileCaseViewComponent } from './juvenile/juvenile-case-view.component';
import { JuvenileComponent } from './juvenile/juvenile/juvenile.component';
import { AllegationsComponent } from './juvenile/allegations/allegations.component';
import { AllegationsAdditionalInfoViewComponent } from './juvenile/allegations/allegations-additional-info/allegations-additional-info.component';
import { AllegationResultComponent } from './juvenile/allegations/allegations-additional-info/allegation-result/allegation-result.component';
import { AllegationUnidisciplinedComponent } from './juvenile/allegations/allegations-additional-info/allegation-undisciplined/allegation-undisciplined.component';
import { AllegationContemptMotionComponent } from './juvenile/allegations/allegations-additional-info/contempt-motion/allegation-contempt-motion.component';
import { DispositionContemptMotionComponent } from './juvenile/allegations/allegations-additional-info/contempt-motion/disposition-contempt-motion.component';
import { DispositionResultComponent } from './juvenile/allegations/allegations-additional-info/disposition-result/disposition-result.component';
import { DispositionUndisciplinedComponent } from './juvenile/allegations/allegations-additional-info/disposition-undisciplined/disposition-undisciplined.component';
import { DispositionDelinquentOffenseComponent } from './juvenile/allegations/allegations-additional-info/disposition-delinquent-offense/disposition-delinquent-offense.component';
import { SupplementalDispositionsComponent } from './juvenile/allegations/allegations-additional-info/supplemental-dispositions/supplemental-dispositions.component';
import { ProbationConditionsComponent } from './juvenile/allegations/allegations-additional-info/probation-conditions/probation-conditions.component';
import { RelatedEventsComponent } from './juvenile/allegations/allegations-additional-info/related-events/related-events.component';
import { RelatedPartiesComponent } from './juvenile/allegations/allegations-additional-info/related-parties/related-parties.component';
import { CaseInformationComponent } from './juvenile/case-information/case-information.component';
import { EventsComponent } from './juvenile/events/events.component';
import { EventsAdditionalInfoViewComponent } from './juvenile/events/events-additional-info/events-additional-info.component';
import { RelatedAllegationsComponent } from './juvenile/events/events-additional-info/related-allegations/related-allegations.component';
import { PartiesDetailsComponent } from './juvenile/parties-details/parties-details.component';
import { StickyHeadersDirective } from './sticky-headers.directive';
import { TableOfContentsDirective } from './table-of-contents.directive';

@NgModule({
  imports: [
    AlertModule,
    CommonModule,
    ModalModule,
    PopoverModule,
    SharedModule,
    AccordionModule,
    RouterModule
  ],
  declarations: [CaseViewComponent,
  CivilCaseViewComponent,
  JudgmentsComponent,
  PleadingsComponent,
  PartiesComponent,
  AttorneysComponent,
  TransferAppealsComponent,
  ServiceDocumentsComponent,
  CaseEventHistoryComponent,
  CivilCaseInformationComponent,
  TranscriptComponent,
  CreditorSectionComponent,
  DocumentsComponent,
  DocumentViewerComponent,
  JuvenileCaseViewComponent,
  JuvenileComponent,
  AllegationsComponent,
  AllegationsAdditionalInfoViewComponent,
  AllegationResultComponent,
  AllegationUnidisciplinedComponent,
  AllegationContemptMotionComponent,
  DispositionContemptMotionComponent,
  DispositionResultComponent,
  DispositionUndisciplinedComponent,
  DispositionDelinquentOffenseComponent,
  SupplementalDispositionsComponent,
  ProbationConditionsComponent,
  RelatedEventsComponent,
  RelatedPartiesComponent,
  CaseInformationComponent,
  EventsComponent,
  EventsAdditionalInfoViewComponent,
  RelatedAllegationsComponent,
  PartiesDetailsComponent,
  StickyHeadersDirective,
  TableOfContentsDirective
],
  exports: [CaseViewComponent, DocumentViewerComponent, StickyHeadersDirective, TableOfContentsDirective],
  providers: [DocumentsService]
})
export class CaseViewModule { }



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/case-view/case-view.module.ts